import { render } from "./IdenticonAddress.vue?vue&type=template&id=1fcf8ed4&scoped=true"
import script from "./IdenticonAddress.vue?vue&type=script&lang=js"
export * from "./IdenticonAddress.vue?vue&type=script&lang=js"

import "./IdenticonAddress.vue?vue&type=style&index=0&id=1fcf8ed4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcf8ed4"]])

export default __exports__